import { ReactElement, ReactNode } from 'react';

interface RadioOptionProps {
  /** Radio group name — options sharing a name are mutually exclusive. */
  name: string;
  value: string;
  checked: boolean;
  onChange: () => void;
  label: string;
  /** Greyed italic note after the label, e.g. "(default)". */
  hint?: ReactNode;
  disabled?: boolean;
}

/**
 * One labelled radio in a vertical group: the control, its label, and an
 * optional italic hint. The session forms all describe their data-source
 * choices this way, so the markup lives here once rather than being spelled
 * out per option.
 */
export default function RadioOption({
  name,
  value,
  checked,
  onChange,
  label,
  hint,
  disabled = false,
}: RadioOptionProps): ReactElement {
  const labelClass = `cr-flex cr-items-center ${disabled ? 'cr-opacity-50' : 'cr-cursor-pointer'}`;
  return (
    <label className={labelClass}>
      <input
        type="radio"
        name={name}
        value={value}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        className="cr-mr-2"
      />
      <span>
        {label}
        {hint ? <> <span className="cr-italic cr-text-gray-500">{hint}</span></> : null}
      </span>
    </label>
  );
}
